import React, { useEffect } from 'react'
import { string } from 'prop-types'
import { css } from '@emotion/react'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'

import NotInstallableButton from './NotInstallableButton'
import { getOwner } from '@/store/selectors'
import { fetchAgents } from '@/store/agents'

const infoCss = css`
  margin: 0;
`

const getOwnerName = (name) => {
  if (!name) {
    return null
  }

  return (
    <>
      , <strong>{name}</strong>,{' '}
    </>
  )
}

const NotEnoughPermission = (props) => {
  const dispatch = useTypedDispatch()
  const owner = useTypedSelector(getOwner, props?.product)

  useEffect(
    () => {
      dispatch(fetchAgents.pending())
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <NotInstallableButton {...props}>
      <p css={infoCss}>
        Sadly, you don't have permissions to install this app. Please let the
        license owner{getOwnerName(owner?.name)} know that you want to try this
        app.
      </p>
    </NotInstallableButton>
  )
}

NotEnoughPermission.propTypes = {
  product: string,
}

export default NotEnoughPermission
